// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__109Z4","inner":"Footer_inner__NwUW7","nextIcon":"Footer_nextIcon__2zso3","innerLeft":"Footer_innerLeft__2TbU8"};